import React, {useEffect} from 'react';
import Container from '@material-ui/core/Container';
import {useHistory} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {isLoggedInState} from "../state/userState";


export default function Home() {
  const history = useHistory();
  const isLoggedIn = useRecoilValue(isLoggedInState)

  useEffect(() => {
    console.log(isLoggedIn)
    if (isLoggedIn) {
      history.push("/sentiment/en")
    } else {
      history.push("/sign-in")
    }
  }, [isLoggedIn, history])

  return (
    <Container />
  );
}

